import { render, staticRenderFns } from "./AvVideoPlay.vue?vue&type=template&id=0f6dc0d7&scoped=true&"
import script from "./AvVideoPlay.vue?vue&type=script&lang=js&"
export * from "./AvVideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./AvVideoPlay.vue?vue&type=style&index=0&id=0f6dc0d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6dc0d7",
  null
  
)

export default component.exports